export default [
  {
    path: '/manufacture-white',
    name: 'manufacture-white',
    component: () => import('@/views/manufacture-white/ManufactureWhite.vue'),
    meta: {
      title: 'Manufacture White ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Manufacture White',
      pageTitle: 'Manufacture White',
      breadcrumb: [
        {
          text: 'Manufacture White',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/manufacture-white/add',
    name: 'add-manufacture-white',
    component: () => import(
      '@/views/manufacture-white/control-manufacture-white/AddEditManufactureWhite.vue'
    ),
    meta: {
      title: 'Add Manufacture White ',
      requiresAuth: true,
      action: 'create',
      resource: 'Manufacture White',
      pageTitle: 'Manufacture White',
      breadcrumb: [
        {
          text: 'Manufacture White',
          to: '/manufacture-white',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/manufacture-white/edit/:id',
    name: 'edit-manufacture-white',
    component: () => import(
      '@/views/manufacture-white/control-manufacture-white/AddEditManufactureWhite.vue'
    ),
    meta: {
      title: 'Edit Manufacture White ',
      requiresAuth: true,
      pageTitle: 'Manufacture White',
      breadcrumb: [
        {
          text: 'Manufacture White',
          to: '/manufacture-white',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
